import React ,{useContext, useEffect, useState}from 'react';
import { Chat } from "../../Context/showChat";
import './PluginSupport.scss';
import {
    Table,
    Button,
    Switch,
    Modal,
    Dropdown,
    Space,
    Menu,
    Tooltip,Select
  } from "antd";


const PluginSupport = () => {
    const { chats,updateChat} = useContext(Chat);
    const [plugins,setplugin ]=useState([
        {
            title: 'Chatbot AI',
            description: 'Get 24/7 help with AI-powered assistant.',
            icon: '🤖',
            isdisabled:false
          },
      {
    isdisabled:false,
        title: 'Service Tracker',
        description: 'Track the status of 311 requests in real time.',
        icon: '🛰️',
      },
      {
    isdisabled:false,
        title: 'City Alerts',
        description: 'Get emergency and public notifications.',
        icon: '📢',
      },
      {
    isdisabled:false,
        title: 'Multilingual Support',
        description: 'Use services in your preferred language.',
        icon: '🌐',
      },
      {
    isdisabled:false,
        title: 'Map Reporting',
        description: 'Report issues using map locations.',
        icon: '🗺️',
      },
      {
    isdisabled:false,
        title: 'Auto Reminders',
        description: 'Never miss a follow-up with reminders.',
        icon: '🔔',
      },
      {
    isdisabled:false,
        title: 'Service History',
        description: 'Access your full service request history.',
        icon: '📂',
      },
      {
    isdisabled:false,
        title: 'Document Upload',
        description: 'Attach files to your service requests.',
        icon: '📎',
      },
      {
    isdisabled:false,
        title: 'Real-Time Chat',
        description: 'Talk live with support staff.',
        icon: '💬',
      },
      {
    isdisabled:false,
        title: 'Department Notifications',
        description: 'Get mobile push updates for requests.',
        icon: '📲',
      },
      {
    isdisabled:false,
        title: 'Feedback Surveys',
        description: 'Provide feedback on completed services.',
        icon: '📝',
      },
      {
    isdisabled:false,
        title: 'Scheduled Services',
        description: 'Book and manage recurring requests.',
        icon: '🗓️',
      },

    ]);

    useEffect(() => {
        const updatedPlugins = plugins.map((plugin) => {
          if (plugin.title === 'Chatbot AI') {
            return { ...plugin, isdisabled: chats }; // sync with context
          }
          return plugin;
        });

        setplugin(updatedPlugins);
      }, [chats]);


  return (
    <div className="plugin-card-container">
      <h2 className="plugin-card-title">🔌  Plugin Features</h2>
      <div className="plugin-card-grid">
        {plugins.map((plugin, index) => (
          <div className="plugin-card" key={index}>
            <div className="plugin-icon">{plugin.icon}</div>
            <h3>{plugin.title}</h3>
            <p>{plugin.description}</p>
            <Tooltip title={"Active / Inactive"}>
              <Switch
               checked={plugin.isdisabled}
             disabled={ plugin.title != 'Chatbot AI' ? true : ''}
             onChange={(checked) => {
                if (plugin.title === 'Chatbot AI') {
                  console.log("Chatbot AI toggled:", checked);
                  updateChat(checked)

                }
              }}
              />
            </Tooltip>
            <div className='mt-2 text-warning'>

            {/* <p className='text-warning'>   {plugin.title != 'Chatbot AI' ? "PAID" : ''}</p> */}

          </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PluginSupport;
